// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c57c9371","812":"94045dc8"}[chunkId] + ".chunk.js";
};